/**
 * Zustand store для toast-уведомлений
 * Дата: 27.12.2025 - Создан для TODO-007 (замена alert на toast)
 * Связан с: frontend/src/hooks/useToast.ts, frontend/src/components/ui/Toast.tsx
 */
import { create } from 'zustand';
import { ToastType } from '@/components/ui/Toast';

interface Toast {
  id: string;
  message: string;
  type: ToastType;
  duration?: number;
}

interface ToastState {
  toasts: Toast[];
  showToast: (message: string, type?: ToastType, duration?: number) => void;
  removeToast: (id: string) => void;
}

export const useToastStore = create<ToastState>((set) => ({
  toasts: [],
  showToast: (message, type = 'info', duration = 5000) => {
    const id = Math.random().toString(36).substring(7);
    set((state) => ({
      toasts: [...state.toasts, { id, message, type, duration }],
    }));
  },
  removeToast: (id) =>
    set((state) => ({
      toasts: state.toasts.filter((toast) => toast.id !== id),
    })),
}));

